document.addEventListener('alpine:init', () => {
    window.Alpine.data('downloadsPage', (initialProps)=> ({
        publicUri: initialProps.publicUri,
        eventFilterOptionIdentifiers: initialProps.eventFilterOptionIdentifiers,
        categoryFilterOptionIdentifiers: initialProps.categoryFilterOptionIdentifiers,
        categoryFilter: '',
        eventFilter: '',
        showList: true,
        showEmptyMessage: false,
        showFilteredEmptyMessage: false,

        init() {
            const params = new URLSearchParams(window.location.search);
            this.categoryFilter = params.get('filter[category]') || '';
            if (this.categoryFilter !== '' && !this.categoryFilterOptionIdentifiers.includes(this.categoryFilter)) {
                this.categoryFilter = '';
                this.updateFilterInParamsAndReplaceHistoryState('category', '');
            }

            this.eventFilter = params.get('filter[event]') || '';
            if (this.eventFilter !== '' && !this.eventFilterOptionIdentifiers.includes(this.eventFilter)) {
                this.eventFilter = '';
                this.updateFilterInParamsAndReplaceHistoryState('event', '');
            }

            this.recomputeViewProperties();

            this.$watch('categoryFilter', (value) => {
                this.updateFilterInParamsAndReplaceHistoryState('category', value);
                this.recomputeViewProperties();
            });

            this.$watch('eventFilter', (value) => {
                this.updateFilterInParamsAndReplaceHistoryState('event', value);
                this.recomputeViewProperties();
            });
        },

        recomputeViewProperties() {
            // Don't update the view properties when the page is loaded in the Neos backend
            if (window.neos) {
                return;
            }

            this.showList = !this.filteredListIsEmpty() && !this.listIsEmpty();
            this.showEmptyMessage = this.filterIsEmpty() && this.listIsEmpty();
            this.showFilteredEmptyMessage = this.filteredListIsEmpty();
        },

        updateFilterInParamsAndReplaceHistoryState(filterName, value) {
            const newLocation = new URL(window.location.href);
            if (value !== '') {
                newLocation.searchParams.set('filter[' + filterName + ']', value);
            } else {
                newLocation.searchParams.delete('filter[' + filterName + ']');
            }
            window.history.replaceState(history.state, '', newLocation.href);
        },

        list() {
            return this.$root.querySelector('.downloads-page__list');
        },

        filterIsEmpty() {
            return this.categoryFilter === '' && this.eventFilter === '';
        },

        get listItems() {
            return Array.from(this.list().querySelectorAll('.teaser-object'));
        },

        get filteredListItems() {
            return this.listItems.filter((item) => {
                const categoryFilters = JSON.parse(item.getAttribute('data-category-filters'));
                const eventFilters = JSON.parse(item.getAttribute('data-event-filters'));
                return (this.categoryFilter === '' || categoryFilters.includes(this.categoryFilter)) && (this.eventFilter === '' || eventFilters.includes(this.eventFilter));
            });
        },

        listIsEmpty() {
            return this.listItems.length === 0;
        },

        filteredListIsEmpty() {
            return !this.listIsEmpty() && this.filteredListItems.length === 0;
        },

        get publicUriWithFilterParams() {
            const uri = new URL(this.publicUri);
            if (this.categoryFilter !== '') {
                uri.searchParams.set('filter[category]', this.categoryFilter);
            }
            if (this.eventFilter !== '') {
                uri.searchParams.set('filter[event]', this.eventFilter);
            }
            return uri.href;
        },
    }));
});
